export const EMBEDDING_SDK_ROOT_ELEMENT_ID = "metabase-sdk-root";
export const EMBEDDING_SDK_PORTAL_ROOT_ELEMENT_ID = "metabase-sdk-portal-root";

export const EMBEDDING_SDK_IFRAME_EMBEDDING_CONFIG = {
  /** Whether the iframe embedding auth flow should be used. */
  isSdkIframeEmbedAuth: false,

  /** Whether we should use the existing user session (i.e. admin user's cookie) */
  useExistingUserSession: false,
};
